import { CategoryUnionType, CompanyLinkType } from '@api';

type IsPersonSettlementsTabEligibleArgsType = {
  companyLinks: Pick<CompanyLinkType, 'categories'>[];
  hasFinanceRead: boolean;
};

const ARTIST_ACCOUNTANT_CATEGORY: CategoryUnionType = 'ARTIST_ACCOUNTANT';

export const isPersonSettlementsTabEligible = ({
  companyLinks,
  hasFinanceRead,
}: IsPersonSettlementsTabEligibleArgsType): boolean => {
  if (!hasFinanceRead) {
    return false;
  }

  return companyLinks.some((companyLink) =>
    companyLink.categories.includes(ARTIST_ACCOUNTANT_CATEGORY)
  );
};
